import { render } from "./reviewCard.vue?vue&type=template&id=03cb48f0&scoped=true"
import script from "./reviewCard.vue?vue&type=script&lang=js"
export * from "./reviewCard.vue?vue&type=script&lang=js"

import "./reviewCard.vue?vue&type=style&index=0&id=03cb48f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03cb48f0"]])

export default __exports__